import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        navState: 'frontend',
        loginState: true,
        userData: {
            firstname: '',
            lastname: '',
            email: '',
            adminid: null,
            profileImg: ''
        }
    },
    mutations: {
        CHANGE_LOGIN_STATE(state, value) {
            state.loginState = value
        },
        CHANGE_NAV_STATE(state, value) {
            state.navState = value
        },
        LOGOUT_USER(state) {
            state.navState = null;

            window.localStorage.removeItem('authUser');
            router.replace('/admin');
        },
        SET_USER_DATA(state, value) {
            state.userData = value;
        }
    },
    actions: {
        
    },
    getters: {
        avatarImage(state) {
            return state.userData.profileImg;
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js